const scene = "address";
export const UPDATE_ADDRESS = `${scene}UPDATE_ADDRESS`;
export const UPDATE_ORDER_PREVIEW = `${scene}UPDATE_ORDER_PREVIEW`;
